const indexItems = [
  { id: 1, title: '动作电影', count: '2,386部', tag: '香蕉视频', letter: 'A' },
  { id: 2, title: '科幻电影', count: '1,852部', tag: '香蕉视频', letter: 'B' },
  { id: 3, title: '悬疑剧集', count: '3,214部', tag: '红桃视频', letter: 'C' },
  { id: 4, title: '古装剧集', count: '1,967部', tag: '红桃视频', letter: 'D' },
  { id: 5, title: '热门综艺', count: '5,430期', tag: '蜜桃视频', letter: 'E' },
  { id: 6, title: '搞笑综艺', count: '3,891期', tag: '蜜桃视频', letter: 'F' },
  { id: 7, title: '经典老片', count: '4,562部', tag: '91视频', letter: 'G' },
  { id: 8, title: '纪录片', count: '1,245部', tag: '91视频', letter: 'H' },
  { id: 9, title: '动漫番剧', count: '2,873部', tag: '香蕉视频', letter: 'I' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">影视索引</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">按类型快速查找感兴趣的高清影视内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <div key={item.id} className="group flex items-center gap-4 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer p-5">
              <div className="w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-500 transition-colors">
                <span className="text-sm font-bold text-primary-600 group-hover:text-background-50 transition-colors">{item.letter}</span>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-950 mb-1 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <span>{item.tag}</span>
                  <span>·</span>
                  <span>{item.count}</span>
                </div>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors text-lg"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}